import React from 'react'
// import ReactGA from 'react-ga'
import banner_1 from "../img/banner_oquefalam_01.png"
import banner_2 from "../img/banner_oquefalam_02.png"
import banner_3 from "../img/banner_oquefalam_03.png"
import bg_1 from "../img/banner_oquefalam_01-bg.png"
import bg_2 from "../img/banner_oquefalam_02-bg.png"
import bg_3 from "../img/banner_oquefalam_03-bg.png"
import small_1 from "../img/banner_oquefalam_01-small.png"
import small_2 from "../img/banner_oquefalam_02-small.png"
import small_3 from "../img/banner_oquefalam_03-small.png"

class Oquefalam extends React.Component{
  constructor(props) {
    super(props)
    this.state = {
    }
  }
  
  componentDidMount () {
    // ReactGA.initialize('UA-55278565-1')
    // ReactGA.pageview('/oquefalam')
  }

  render() {
    return (
      <section id="porque" className="oque">
        <div className="bannerOque">
          <div className="slice">
            <img src={banner_1} />
            <img src={small_1} />
            <img src={bg_1} />
          </div>
          <div className="slice">
            <img src={banner_2} />
            <img src={small_2} />
            <img src={bg_2} />
          </div>
          <div className="slice">
            <img src={banner_3} />
            <img src={small_3} />
            <img src={bg_3} />
          </div>
        </div>
      </section>
    )
  }
}

export default Oquefalam